"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _default = function _default(_ref) {
  var index = _ref.index,
    currentIndex = _ref.currentIndex,
    changeCurrentIndex = _ref.changeCurrentIndex;
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
    size: "small",
    name: index === currentIndex ? 'circle' : 'circle outline',
    inverted: true,
    onClick: function onClick() {
      return changeCurrentIndex(index);
    }
  });
};
exports["default"] = _default;